<template>
<div class="text-xs-center" style="position: relative">
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-avatar
      v-if="url && !base64Data"
      :tile="tile"
      slot="activator"
      @click="onStart"
      :size="size">
      <img
        :src="url"
        alt="Avatar"
        height="100px"
        >
      </v-avatar>
    <v-icon v-if="!base64Data && !url" @click="onStart" slot="activator" color="primary" :size="sizeIcon">{{ icon }}</v-icon>
    <v-avatar
      :tile="tile"
      v-if="base64Data"
      slot="activator"
      @click="onStart"
      :size="size">
      <img
        :src="base64Data"
        alt="Avatar"
        height="100px"
        >
    </v-avatar>
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="onStop">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('register.take_picture') }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-title primary-title>
        <v-flex xs12>
          <v-select
            v-model="camera"
            :items="devices"
            item-text="label"
            item-value="deviceId"
            ></v-select>
        </v-flex>

        <web-cam ref="webcam"
                 :device-id="deviceId"
                 width="100%"
                 height="90%"
                 @stopped="onStopped"
                 @cameras="onCameras"
                 @camera-change="onCameraChange" />

          <v-btn small color="accent" @click="onCapture">{{ $t('buttons.capture_photo') }}</v-btn>
          <v-btn small @click="onStop">{{ $t('buttons.stop_camera') }}</v-btn>
          <v-btn small @click="onStart">{{ $t('buttons.start_camera') }}</v-btn>
      </v-card-title>
    </v-card>
  </v-dialog>
    <div v-if="updateIcon && (url || base64Data)" @click="update" class="card-img-overlay" :style="{ width:  size + 'px'}"><button id="pick-avatar" class="btn btn-primary btn-sm">{{ $t('account.update_photo') }}</button></div>
</div>
</template>

<script>
import { find, head } from 'lodash'
import WebCam from './Webcam'

export default {
  name: 'AvatarWeb',

  data () {
    return {
      dialog: false,
      img: null,
      camera: null,
      deviceId: null,
      devices: []
    }
  },

  components: {
    WebCam
  },

  computed: {
    base64Data: function () {
      return this.$store.getters['Device/getBase64']
    },
    device: function () {
      return find(this.devices, n => n.deviceId === this.deviceId)
    }
  },

  watch: {
    camera: function (id) {
      this.deviceId = id
    },
    devices: function () {
      // Once we have a list select the first one
      let first = head(this.devices)
      if (first) {
        this.camera = first.deviceId
        this.deviceId = first.deviceId
      }
    }
  },

  props: {
    'icon': {
      default: 'account_circle',
      type: String
    },
    'url': {
      default: '',
      type: String
    },
    'tile': {
      default: false,
      type: Boolean
    },
    'updateIcon': {
      default: false,
      type: Boolean
    },
    'size': {
      default: '150px',
      type: String
    },
    'sizeIcon': {
      default: '80',
      type: String
    }
  },

  methods: {
    update () {
      this.dialog = !this.dialog
      this.onStart()
    },
    onCapture () {
      this.$store.dispatch('Device/saveBase64', this.$refs.webcam.capture())
      this.$refs.webcam.stop()
      this.dialog = false
    },
    onStarted (stream) {
    },
    onStopped (stream) {
    },
    onStop () {
      this.$refs.webcam.stop()
      this.dialog = false
    },
    onStart () {
      this.$refs.webcam.start()
    },
    onCameras (cameras) {
      this.devices = cameras
    },
    onCameraChange (deviceId) {
      this.deviceId = deviceId
      this.camera = deviceId
    }
  }
}
</script>

<style>
  .card-img-overlay {
    background: rgba(0,0,0,.54);
    transition: all 0.5s;
  }
  .card-img-overlay {
      position: absolute;
      border-radius:0 0 200px 200px;
      max-width:480px;
      color: #fff;
      top: 50%;
      margin-left: auto;
      margin-right: auto;
      line-height: 18px;
      right: 0;
      bottom: 0;
      left: 0;
  }
</style>
